export const HOMEPAGE_URL = "https://coconutsilo.com/";

export const PERSONAL_INFORMATION_POLICY_URL =
  "https://truckdoctor.co.kr/repairshop/privacy";

export const TERMS_OF_USE_URL = "https://truckdoctor.co.kr/repairshop/terms";
